class FetchAiCostLimitSubjects {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAiCostLimitSubjects;
